import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { concat, of, from, Subscription, Subject } from 'rxjs';
import { map, filter, concatMap, switchMap } from 'rxjs/operators';

import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { FilterService } from 'primeng/api';

import { environment } from 'src/environments/environment';

import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { RestApiService } from 'src/app/services/rest-api.service';
import { PrintReportSetting } from 'src/app/shared/global-settings-data';
import { DocTypes } from 'src/app/shared/doc-list-entry';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';

@Component({
  selector: 'app-edit-print-reports',
  templateUrl: './edit-print-reports.component.html',
  styleUrls: ['./edit-print-reports.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditPrintReportsComponent implements OnInit, OnDestroy {

  public mainCompany: number;
  docTypes: DocTypes[];

  selectedDocType: DocTypes;

  rows: number = 25;
  totalRecords: number;
  loading: boolean = false;
  paginator: boolean = false;

  editMode: boolean = false;
  confirmDeleteOn: boolean;

  typeDeleteConfirmation: boolean = false;
  confirmText: string = 'DELETE 12';
  deleteAllRows: boolean = false;

  allowEditControls: boolean = true;

  public get noItems(): boolean { return ((this.reportList || []).length < 1); }

  private reportListQuery: Subscription;
  private saveReportListQuery: Subscription;
  private docTypeQuery: Subscription;
  private personNameQuery: Subscription;

  reportList: PrintReportSetting[] = [];
  reportListClone: PrintReportSetting[] = [];

  repLlist$ = new Subject<boolean>();

  selectedReport: PrintReportSetting;

  @ViewChild('rlTable') rlTable: Table;

  cf3: any = {};
  constructor(
    private messageService: MessageService,
    private globalsettingsservice: GetglobalsettingsService,
    private restApi: RestApiService,
    private docApi: DocumentApiService,
    private cliApi: ClientApiService,
    private filterService: FilterService
  ) {
  }

  ngOnDestroy(): void {
    console.log('*** EditPrintReportsComponent ngOnDestroy: ');

    if (this.reportListQuery) { this.reportListQuery.unsubscribe(); }
    if (this.saveReportListQuery) { this.saveReportListQuery.unsubscribe(); }
    if (this.personNameQuery) { this.personNameQuery.unsubscribe(); }
    if (this.docTypeQuery) { this.docTypeQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** EditPrintReportsComponent onInit');

    this.filterService.register('inCollection', (value: number, filter: any[]) => (filter.find(e => e.DOCTYPE == value)));

    this.mainCompany = this.globalsettingsservice.getMainCompanyId();

    this.reportListQuery =
      this.repLlist$.pipe(
        switchMap(opt => this.restApi.getPrintReportsList())
      )
        .subscribe(list => {
          console.log('*** EditPrintReportsComponent onInit: load ');
          this.reportList = list;
          this.totalRecords = list.length;

          this.paginator = (this.totalRecords > this.rows);

          this.personNameQuery =
            from(this.reportList)
              .pipe(
                concatMap(r => {
                  return concat(
                    this.cliApi.getClientById(r.LCOCLIID).pipe(filter(e => e[0].CLIID != 0), map(cli => r.CLIENTNAME = cli[0].CLIENTSNIKNAME)),
                    this.cliApi.getPerListEntry(r.PERSID).pipe(filter(e => e[0].PERSID != 0), map(per => r.PERSONNAME = per[0].personLastName)),
                    of(r).pipe(map(rp => {
                      rp.cloneIndex = 0;
                      rp.DOCTYPENAME = (this.docTypes.find(e => rp.DOCTYPE == e.DOCTYPEID) || { 'DOCNAME1': 'Other Reports' }).DOCNAME1;

                    }))
                  );
                }))
              .subscribe();
        });

    this.docTypeQuery =
      this.docApi.getDocTypes()
        .pipe()
        .subscribe(types => {
          this.docTypes = types;
          this.repLlist$.next(true);
        });
  }

  onRowSelect(selectedId) {
    console.log('*** EditPrintReportsComponent in onRowSelect: ' + JSON.stringify(selectedId));
    }

  onRowUnselect(selectedId) {
    console.log('*** EditPrintReportsComponent in onRowUnselect: ' + JSON.stringify(selectedId));
  }

  onAddRow(event) {
    console.log('*** EditPrintReportsComponent in onAddRow: ' + JSON.stringify(event));

    let newDi: PrintReportSetting = {

      CLIID: this.mainCompany,
      PERSID: null,
      DOCTYPE: 0,
      LCOCLIID: null,
      REPORTID: -2,
      REPORTOPT: 0,
      REPORTNAME: 'New Print Report',
      REPORTSERVER: '',
      REPORTSRVOPT: '',
      cloneIndex: 0
    };

    this.reportList = [...this.reportList, newDi]

    let ppe: PrintReportSetting = this.reportList.find(e => e.REPORTID == -2);
    this.onRowEditInit(ppe);
    this.rlTable.initRowEdit(ppe);
  }

  onRowEditInit(esg: PrintReportSetting) {
    console.log('*** EditPrintReportsComponent in onRowEditInit: entry');
    environment.production || console.table(esg);

    let newCloneIndex: number = 0;

    /*
     * Quite tricky algoritm:
     * Because we can edit simultaneously more than one row in the table.
     * Therefore for every edited row we have to create cloned copy in shadow array [securityGroupsClone]
     * We can't predict the order of starting and ending the edit process
     * 
     * So - Search for max cloneIndex in current table and assign +1 to newly created row copy
     *
     * When row either cancelled or saved - clone index resetted to 0, clone copy deleted from shadow array
     *
     */
    this.reportListClone.forEach(sg => { newCloneIndex = Math.max(newCloneIndex, sg.cloneIndex) });

    console.log('*** EditPrintReportsComponent in onRowEditInit: newCloneIndex is: ' + newCloneIndex);

    esg.cloneIndex = ++newCloneIndex;
    this.reportListClone.push({ ...esg });

    this.selectedDocType = this.docTypes.find(e => e.DOCTYPEID == esg.DOCTYPE);

    this.editMode = true;
  }

  onRowEditCancel(esg: PrintReportSetting, index: number) {
    console.log('*** EditPrintReportsComponent in onRowEditCancel: ' + index);
    environment.production || console.table(esg);

    if (esg.REPORTID == -2) {
      // Cancel the newly created record
      // simply delete

      this.reportList.splice(index, 1);

    } else {
      // Cancel editing of existing record
      // have to reload it from database

      this.reportList[index] = { ...this.reportListClone.find(sg => sg.cloneIndex == esg.cloneIndex) };
      this.reportList[index].cloneIndex = 0;
    }

    this.reportListClone
      .splice(this.reportListClone.findIndex(sg => sg.cloneIndex == esg.cloneIndex), 1);

    this.editMode = false;
  }

  onRowEditSave(esg: PrintReportSetting) {
    console.log('*** EditPrintReportsComponent in onRowEditSave: ');
    environment.production || console.table(esg);

    if (esg.REPORTID == -2) {
      this.saveReportListQuery =
        this.restApi.postPrintReport(esg).subscribe(() => {
          console.log('*** EditUserAccessComponent in onSubsribe to Post: ');
          this.reportListClone.splice(this.reportListClone.findIndex(sg => sg.cloneIndex == esg.cloneIndex), 1);
          esg.cloneIndex = 0;

          this.repLlist$.next(true);
        });
    } else {
      this.saveReportListQuery =
        this.restApi.putPrintReport(esg).subscribe(() => {
          console.log('*** EditUserAccessComponent in onSubsribe to Put: ');
          this.reportListClone.splice(this.reportListClone.findIndex(sg => sg.cloneIndex == esg.cloneIndex), 1);
          esg.cloneIndex = 0;

          this.repLlist$.next(true);
        });
    }
    this.editMode = false;
}

  onDocTypeChange(event, rp: PrintReportSetting) {
    console.log('*** EditPrintReportsComponent in onDocTypeChange: ' + JSON.stringify(event));

    rp.DOCTYPE = (event && event.value) ? event.value.DOCTYPEID : 0;

    console.log('*** EditPrintReportsComponent in onDocTypeChange: ' + JSON.stringify(rp));

  }

  mainPersonSelected(event, rp: PrintReportSetting) {
    console.log('*** EditPrintReportsComponent in mainPersonSelected: ' + JSON.stringify(event));

    rp.PERSID = event;
  }

  lcoCompanySelected(event, rp: PrintReportSetting) {
    console.log('*** EditPrintReportsComponent in lcoCompanySelected: ' + JSON.stringify(event));

    rp.LCOCLIID = event;
  }

  onRemoveAllRow(event) {
    console.log('*** EditPrintReportsComponent in onRemoveAllRow: ' + JSON.stringify(event));

    this.deleteAllRows = true;
    this.confirmText = 'DELETE ' + this.reportList.length;
    this.typeDeleteConfirmation = true;
    this.confirmDeleteOn = true;
  }

  onRemoveRow(event) {
    console.log('*** EditPrintReportsComponent in onRemoveRow: ' + JSON.stringify(event));
    this.deleteAllRows = false;
    this.typeDeleteConfirmation = false;
    this.confirmDeleteOn = true;
  }

  onDeleteConfirmation(event) {
    console.log('*** EditPrintReportsComponent onDeleteConfirmation: ' + JSON.stringify(event));
    this.confirmDeleteOn = false;

    if (event) {
      console.log('*** EditPrintReportsComponent onDeleteConfirmation DO DELETE!!! NOW!!!');

      if (this.deleteAllRows) {
        console.log('*** EditPrintReportsComponent onDeleteConfirmation DO DELETE ALL !!! NOW!!! ********** ALL ********');
        this.restApi.deleteAllPrintReportNotImplemented()
          .subscribe(() => {
            console.log('*** EditPrintReportsComponent onDeleteAllItemsConfirmation: DONE!');
            this.repLlist$.next(true);
          });
      } else {
        if (this.selectedReport) {
          this.restApi.deletePrintReportById(this.selectedReport)
            .subscribe(() => {
              console.log('*** EditPrintReportsComponent onDeleteConfirmation: DONE!');
              this.repLlist$.next(true);
            });
        }
      }
    }
  }

 onStateSave(state) {
    //    console.log('*** EditUserAccessComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestore(state) {
    console.log('*** EditPrintReportsComponent onStateRestore: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        this.cf3[f] = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;

        switch (f) {
          case 'REPORTID':
            break;
        }
      }
    }
  }

  clearOrResetTableFilter(event) {
    this.rlTable.clear();
    this.rlTable.clearState();
  }
}
